import { PublicationsView } from 'src/screens/Private/Publications';
import { MenuItem } from '../../../../commons/ui/menu';

export const routes: MenuItem[] = [
  {
    key: 'publicationsMain',
    basePath: '/',
    target: {
      component: PublicationsView,
      path: '/',
    },
    enabled: true,
    icon: 'List',
    text: 'Publications',
    children: [],
    default: true,
  },
];
